var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPin = function SvgPin(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-24": 18,
    viewBox: "0 0 18 18",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.274 15.962a1.94 1.94 0 0 0 1.21.4q.291-.012.57-.1a2 2 0 0 0 1.34-1.3l1.34-4 2.82-4.25a2.26 2.26 0 0 0-.29-2.84l-3.25-3.21a2.26 2.26 0 0 0-2.84-.29l-4.21 2.82-4 1.34a2 2 0 0 0-1.33 1.34 1.93 1.93 0 0 0 .33 1.78 49 49 0 0 0 3.365 3.862L.224 16.682a.74.74 0 0 0 0 1.06.7.7 0 0 0 .53.22.74.74 0 0 0 .53-.26l5.13-5.103a49 49 0 0 0 3.86 3.363M7.1 11.148a47 47 0 0 0 4.063 3.584.46.46 0 0 0 .43.08.48.48 0 0 0 .34-.33l1.38-4.16a.8.8 0 0 1 .09-.18l2.87-4.3a.73.73 0 0 0-.1-.94l-3.21-3.18a.7.7 0 0 0-.5-.22h.013a.75.75 0 0 0-.404.12l-4.3 2.87a.8.8 0 0 1-.18.09l-4.18 1.38a.48.48 0 0 0-.33.34.46.46 0 0 0 .08.43 47 47 0 0 0 3.613 4.092.77.77 0 0 1 .325.324",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPin);
export default ForwardRef;